import config from './config'
// 时间过滤器
const showImgUrl = url => {
  if (url) {
    return config.BASE_IMG_URL + url
  }
}
export { showImgUrl }
